import { ModuleConfiguration, ModuleName } from './types';

export const moduleConfigurations: Record<ModuleName, ModuleConfiguration> = {
  footer: { isPublic: true, isPage: false },
  galleryEditor: { isPage: true, waitFor: { shopToken: true } },
  galleryReader: { isPage: true, waitFor: { shopToken: true } },
  galleryShared: { isPublic: true, isPage: true },
  invoices: { isPage: true, waitFor: { shopToken: true } },
  licenseAssignment: { isPage: true },
  login: { isPublic: true, isPage: true },
  subscription: { isPage: true, requires: { paymentProvider: true } },
  survey: { isPage: false },
  topMenu: { isPublic: true, isPage: false },
  uploadManagement: { isPage: true, waitFor: { shopToken: true } },
  uploadManagementSharedContent: { isPublic: true, isPage: true },
  userManagement: { isPage: true },
  billingInformation: { isPage: true, requires: { paymentProvider: true } },
  paymentMethod: { isPage: true, requires: { paymentProvider: true } },
  oldSubscriptions: { isPage: true, requires: { paymentProvider: true } },
  noSubscriptions: { isPage: true },
};
